import React, { useState, useEffect } from 'react'

import { Button, Card, CardContent } from '@material-ui/core'
import { useFormik } from 'formik'
import {
  SelectInput,
} from '../../../../components/Forms'
import {
  FormGroup,
  ButtonWrapperFilter,
  useStyles,
  Splitter,
} from '../../../../styles/common-styles'
import { useTranslation } from 'react-i18next'
import { financialAid_report } from '../../../../services/navigation_folder/financialAid'
import PopupHeader from '../../../common-page/popupHeader'
import * as yup from 'yup'
import {
  more_tab_add_report,
  more_tab_acadmecId,
  getReportData,
  standardByAward,
  standardByPackageReport,
  mcStandardByPackageReport,
  mcStandardByAward,
  mcColumnsByPackageReport,
} from '../../../../services/apiURL'
import { getApi } from '../../../../services/apiBase'
import { updateAccessSelector } from '../../../../redux/common/roleAccess/selectors'
import { useSelector } from 'react-redux'
import { maintenance } from '../../../../helper/constants'
import { postApi } from '../../../../services/apiBase'
import { getFile } from '../../../../utils/common/common'
import ExportComponent from '../../../../utils/Export/ExportComponent'
import CustomLoader from '../../../../components/Loader/Loader'
import GenericModal from '../../../../components/Modal/GenericModal'

const AddReport = ({ onClose, selectedRow }) => {
  const { t } = useTranslation([
    'translation',
    'financialAid',
    'financialAidHeadcells',
  ])
  const classess = useStyles()
  const initialValues = {
    reports: '',
    academicYears: '',
    financialAidYear: '',
    addressTypes: '',
    terms: '',
    termTo: ''
  }

  const numField = (fieldLabel) =>
    yup
      .number()
      .transform((val, originalValue) => {
        // Convert empty string or NaN to undefined so required()/when() works as expected
        if (originalValue === '' || originalValue === null || Number.isNaN(val)) return undefined
        return val
      })
      .typeError(t('validationMessages.isRequired', { what: fieldLabel }))
      .min(1, t('validationMessages.isRequired', { what: fieldLabel }))

  const validationSchema = yup.object({
    reports: numField(t('commonLabel.selectReport', { ns: 'financialAid' }))
      .required(
        t('validationMessages.isRequired', {
          what: t('commonLabel.selectReport', { ns: 'financialAid' }),
        }),
      ),

    // Require academicYears and financialAidYear for reports 1,3,4,6
    academicYears: numField(t('commonLabel.academicYear', { ns: 'financialAid' }))
      .when('reports', {
        is: (v) => [1, 3, 4, 6].includes(v),
        then: (schema) =>
          schema.required(
            t('validationMessages.isRequired', {
              what: t('commonLabel.academicYear', { ns: 'financialAid' }),
            }),
          ),
        otherwise: (schema) => schema.notRequired(),
      }),
    financialAidYear: numField(t('commonLabel.financialAidYear', { ns: 'financialAid' }))
      .when('reports', {
        is: (v) => [1, 3, 4, 6].includes(v),
        then: (schema) =>
          schema.required(
            t('validationMessages.isRequired', {
              what: t('commonLabel.financialAidYear', { ns: 'financialAid' }),
            }),
          ),
        otherwise: (schema) => schema.notRequired(),
      }),

    // Require term range for reports 2,5
    terms: numField(t('commonLabel.termFrom'))
      .when('reports', {
        is: (v) => [2, 5].includes(v),
        then: (schema) =>
          schema.required(
            t('validationMessages.isRequired', { what: t('commonLabel.termFrom') }),
          ),
        otherwise: (schema) => schema.notRequired(),
      }),
    termTo: numField(t('commonLabel.termTo'))
      .when('reports', {
        is: (v) => [2, 5].includes(v),
        then: (schema) =>
          schema.required(
            t('validationMessages.isRequired', { what: t('commonLabel.termTo') }),
          ),
        otherwise: (schema) => schema.notRequired(),
      }),

    // Address type required whenever a report is chosen
    addressTypes: numField(t('commonLabel.addressType', { ns: 'financialAid' }))
      .when('reports', {
        is: (v) => !!v,
        then: (schema) =>
          schema.required(
            t('validationMessages.isRequired', {
              what: t('commonLabel.addressType', { ns: 'financialAid' }),
            }),
          ),
        otherwise: (schema) => schema.notRequired(),
      }),
  })

  const handleAcademicYear = (e) => {
    formik.handleChange(e)
    const { value } = e.target
    getApi(`${more_tab_acadmecId}/${value}`)
      .then((resp) => {
        setDropdown({
          ...Dropdown,
          finacialDrop: resp.data.data,
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const handleGenerateReport = (values) => {
    const reportFormat = values.reports;

    const payload = {
        studentUID: selectedRow.studentUID, // From maintenance context
        financialAidYearID: values.financialAidYear || 0,
        academicYearID: values.academicYears || 0,
        addressTypeID: values.addressTypes || 0,
        termFromID: values.terms || 0,
        termToID: values.termTo || 0,
        // Default values
        awardType: [0],
        awardStatus: [0],
        creditStatus: [0],
        code1: [0],
        code2: [0],
        directCostType: [0],
        packageStatus: [0],
        studentStatusTerm: [0],
        campus: [],
        collegeLevel: [],
        cohortGroup: [],
        studentAccepted: "",
        showOtherAwardAlso: "",
        awardDistributionFrom: null,
        awardDistributionTo: null,
        awardCreatedFrom: null,
        awardCreatedTo: null,
        awardChangedFrom: null,
        awardChangedTo: null,
    };

    // Call appropriate API endpoint based on reportFormat
    const apiEndpoints = {
        1: getReportData,
        2: standardByAward,
        3: standardByPackageReport,
        4: mcStandardByPackageReport,
        5: mcStandardByAward,
        6: mcColumnsByPackageReport,
    };

    const endpoint = apiEndpoints[values.reports];
    if (!endpoint) return;

    setIsSpinner(true);
    postApi(endpoint, payload).then((res) => {
        if (res.data.data.studentDetails.length > 0) {
            // Load appropriate HTML/CSS template
            const templatePaths = {
                1: 'ColumnsByPackage',
                2: 'StandardByAward',
                3: 'StandardByPackage', 
                4: 'MCStandardByPackage',
                5: 'MCStandardByAward',
                6: 'MCColumnsByPackage',
            };

            const templateName = templatePaths[reportFormat];
            const HTMLString = getFile(`${window.location.origin}/ReportHTML/FinancialAid/report/AwardLetters/SingleStudent/${templateName}/index.html`);
            const HTMLCss = getFile(`${window.location.origin}/ReportHTML/FinancialAid/report/AwardLetters/SingleStudent/${templateName}/index.css`);

            ExportComponent(HTMLString, HTMLCss, res.data.data);
        } else {
            setOpenAlert(true);
        }
    }).catch((error) => {
        console.log(error);
    }).finally(() => {
        setIsSpinner(false);
    });
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: handleGenerateReport
  })

  const [Dropdown, setDropdown] = useState({
    reportsDrop: [],
    addressTypeDrop: [],
    academicDrop: [],
    finacialDrop: [],
    termDrop: []
  })

  const [isSpinner, setIsSpinner] = useState(false)
  const [openAlert, setOpenAlert] = useState(false)

  useEffect(() => {
    getApi(more_tab_add_report)
      .then((resp) => {
        const {
          academicYears,
          addressTypes,
          reports,
          terms
        } = resp.data.data
        setDropdown({
          ...Dropdown,
          reportsDrop: reports,
          addressTypeDrop: addressTypes,
          academicDrop: academicYears,
          termDrop: terms
        })
      })
      .catch((err) => {
        console.log(err)
      })
    document.getElementsByTagName("html")[0].classList.add("popup-Page");
  }, [])

  // Role based access control redux
  const { access } = useSelector(updateAccessSelector)
  const { nestedParentLevel } = access;
  const [statusAccess, setStatusAccess] = useState({
    maintenance: 2,
  })
  useEffect(() => {
    let finStatusAccess = nestedParentLevel.filter((v, i) =>
      v.menuItemName.trim() === maintenance && v.moduleorder === 4
    )

    setStatusAccess({
      ...statusAccess,
      maintenance: (finStatusAccess.length > 0) ? finStatusAccess[0].menuAccess : 2,
    })

  }, [access])
  const [accessFlag, setAccessFlag] = useState(false)
  useEffect(() => {
    (statusAccess.maintenance !== 2) ? setAccessFlag(true) : setAccessFlag(false)
  }, [statusAccess])
  //RBA Ends here

  return (
    <>
      {isSpinner ? <CustomLoader /> : ""}
      <PopupHeader
        title={t('commonLabel.reportOptions', { ns: 'financialAid' })}
        navigationList={financialAid_report}
        onClose={onClose}
      />
      <form className={classess.root} onSubmit={formik.handleSubmit}>
        <Card>
          <CardContent>
            <FormGroup>
              <SelectInput
                label={t('commonLabel.selectReport', { ns: 'financialAid' })}
                labelId={'reports'}
                formikValue={formik.values.reports}
                formikChange={formik.handleChange}
                errors={formik.errors.reports}
                touched={formik.touched.reports}
                disabled={accessFlag}
                mandatory
                dropdownData={{
                  key: 'displayText',
                  value: 'uniqueId',
                  optionLists: Dropdown.reportsDrop,
                }}
              />
            </FormGroup>
            {[1, 3, 4, 6].includes(formik.values.reports) ?
              <>
                <FormGroup>
                  <SelectInput
                    label={t('commonLabel.academicYear', { ns: 'financialAid' })}
                    labelId={'academicYears'}
                    formikValue={formik.values.academicYears}
                    formikChange={handleAcademicYear}
                    errors={formik.errors.academicYears}
                    touched={formik.touched.academicYears}
                    mandatory
                    dropdownData={{
                      key: 'displayText',
                      value: 'uniqueId',
                      optionLists: Dropdown.academicDrop,
                    }}
                  />
                  <SelectInput
                    label={t('commonLabel.financialAidYear', {
                      ns: 'financialAid',
                    })}
                    labelId={'financialAidYear'}
                    formikValue={formik.values.financialAidYear}
                    formikChange={formik.handleChange}
                    errors={formik.errors.financialAidYear}
                    touched={formik.touched.financialAidYear}
                    mandatory
                    dropdownData={{
                      key: 'displayText',
                      value: 'uniqueId',
                      optionLists: Dropdown.finacialDrop,
                    }} />
                </FormGroup>
              </> : [2, 5].includes(formik.values.reports) &&
              <FormGroup>
                <SelectInput
                  label={t('commonLabel.termFrom', { ns: 'financialAid' })}
                  labelId={'terms'}
                  formikValue={formik.values.terms}
                  formikChange={formik.handleChange}
                  errors={formik.errors.terms}
                  touched={formik.touched.terms}
                  mandatory
                  dropdownData={{
                    key: 'displayText',
                    value: 'uniqueId',
                    optionLists: Dropdown.termDrop,
                  }}
                />
                <SelectInput
                  label={t('commonLabel.to', { ns: 'financialAid' })}
                  labelId={'termTo'}
                  formikValue={formik.values.termTo}
                  formikChange={formik.handleChange}
                  errors={formik.errors.termTo}
                  touched={formik.touched.termTo}
                  mandatory
                  dropdownData={{
                    key: 'displayText',
                    value: 'uniqueId',
                    optionLists: Dropdown.termDrop,
                  }}
                />
              </FormGroup>}
            {formik.values.reports ?
              <FormGroup>
                <SelectInput
                  label={t('commonLabel.addressType', { ns: 'financialAid' })}
                  labelId={'addressTypes'}
                  formikValue={formik.values.addressTypes}
                  formikChange={formik.handleChange}
                  errors={formik.errors.addressTypes}
                  touched={formik.touched.addressTypes}
                  mandatory
                  dropdownData={{
                    key: 'displayText',
                    value: 'uniqueId',
                    optionLists: Dropdown.addressTypeDrop,
                  }}
                />
              </FormGroup> : null}
            <Splitter height={'10px'} />
            <div style={{ display: 'flex' }}>
              <ButtonWrapperFilter>
                <Button
                  aria-label={'Send'}
                  className="BgYellowOrange Search"
                  variant="contained"
                  size="large"
                  type='submit'
                disabled={accessFlag}
                >
                  {t('buttonLabel.print', { ns: 'financialAid' })}
                </Button>
                <Button
                  aria-label={'Cancel'}
                  className="BgLightBlue"
                  variant="contained"
                  size="large"
                  onClick={() => onClose('')}
                >
                  {t('buttonLabel.cancel', { ns: 'financialAid' })}
                </Button>
              </ButtonWrapperFilter>
            </div>
          </CardContent>
        </Card>
      </form>
      <GenericModal 
        open={openAlert}
        content={"No student details found for the selected criteria."}
        onClose={setOpenAlert}
        buttonText={'Ok'}        
      />
    </>
  )
}
export default AddReport
